var _taggedTemplateLiteral = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DISCOUNT_APPLICATION_FRAGMENT = void 0;

var graphql_tag_1 = __importDefault(require("graphql-tag"));

exports.DISCOUNT_APPLICATION_FRAGMENT = (0, graphql_tag_1.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment DiscountApplicationFragment on DiscountApplication {\n    targetSelection\n    allocationMethod\n    targetType\n    value {\n      ... on MoneyV2 {\n        amount\n        currencyCode\n      }\n      ... on PricingPercentageValue {\n        percentage\n      }\n    }\n    ... on ManualDiscountApplication {\n      title\n      description\n    }\n    ... on DiscountCodeApplication {\n      code\n      applicable\n    }\n    ... on ScriptDiscountApplication {\n      description\n    }\n    ... on AutomaticDiscountApplication {\n      title\n    }\n  }\n"])));